import * as React from 'react'
import { useMemo } from 'react'
import BaseTravelOverview, { BaseTravelLineOverviewProps, BaseTravelOverviewProps, TravelFilterType } from './BaseTravelOverview'
import TravelListItem from './TravelListItem'

export type FileTravelOverviewProps = Partial<BaseTravelOverviewProps> & {
    baseUrl: string
    fileId: string
    localStorageKeyPrefix?: string
}

/**
 * The travel overview within a dossier (HAM-3627): the travel lines of the file. All data loading,
 * the filter, the create button and the add/edit popup come from BaseTravelOverview; this wrapper
 * only scopes to the file (hiding the redundant file filter).
 */
export default function TravelOverview(props: FileTravelOverviewProps) {
    const fixedFilterValues = useMemo<Partial<TravelFilterType>>(() => ({ files: props.fileId ? [props.fileId] : undefined }), [props.fileId])

    return (
        <BaseTravelOverview
            {...props}
            fixedFilterValues={fixedFilterValues}
            hideFileField={!!props.fileId}
            listItemContent={(itemProps: BaseTravelLineOverviewProps) => <TravelListItem {...itemProps} hideFileField renderLink={false} />}
        />
    )
}
